import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileUploaderClassComponent} from '@components/files-uploader/file-uploader.class.component';
import {MimeTypeNamespace} from '@namespaces/mime-type.namespace';
import {FilesUploaderService} from '@components/files-uploader/files-uploader.service';
import {ImageCropperModalComponent} from '@components/files-uploader/image-cropper-modal/image-cropper-modal.component';
import MimeEnums = MimeTypeNamespace.MimeEnums;
import {PreviewModalService} from '@services/preview-modal.service';

@Component({
    selector: 'app-single-file-uploader',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'single-file-uploader.component.html'
})

export class SingleFileUploaderComponent extends FileUploaderClassComponent implements OnInit {

    /**
     * Запускать кроппер для изображений
     */
    @Input() cropImages = true;
    @Input() ratio = NaN;
    @Input() height = 140;

    /**
     * Показывать сообщение о возможных типах файлов
     */
    @Input() showInfoMessage = true;

    /**
     * Разрешить загрузку различных типов данных
     */
    @Input() acceptPdf = true;
    @Input() acceptTiff = false;
    @Input() acceptOfficeFiles = false;

    @ViewChild(ImageCropperModalComponent) private cropper: ImageCropperModalComponent;

    accept = [];

    public infoMessage: string;

    constructor(
        uploader: FilesUploaderService,
        cd: ChangeDetectorRef,
        private filesPreviewService: PreviewModalService,
    ) {
        super(uploader, cd);
    }

    ngOnInit() {
        super.ngOnInit();

        if (this.acceptPdf) {
            this.accept.push(MimeEnums.pdf);
        }

        this.accept.push(...MimeTypeNamespace.getImageTypes());

        if (this.acceptTiff) {
            this.accept.push(MimeEnums.tiff);
        }

        if (this.acceptOfficeFiles) {
            this.accept.push(
                ...MimeTypeNamespace.getOfficeTypes(),
                MimeEnums.csv
            );
        }

        this.prepareInfoMessage(this.accept);
    }

    public afterSelectedFileValidation() {
        const isImage = MimeTypeNamespace.isImage(this.queueItem.file.type);

        /**
         * Если нужен кроппер картинок и сейчас картинка, то вызываем кроппер
         */
        if (isImage && this.cropImages) {
            this.cropper.showCropper(this.queueItem.file);
        } else {
            this.uploadSingle();
        }
    }

    public showFilePreview() {
        if (!this.filePreview) {
            return;
        }

        this.filesPreviewService.show({
            files: [this.filePreview.rawFile]
        });
    }

    /**
     * Когда картинка успешно кропнулась
     * @param image
     */
    onImageCropped(image: Blob) {
        this.queueItem.file = image;
        this.uploadSingle();
        this.updateView$.next();
    }

    /**
     * При ошибке кроппа картинки
     * @param message
     */
    onImageCroppedError(message: string) {
        this.queueItem.setError(message);
        this.updateView$.next();
    }

    /**
     * Подготовить информационное сообщение о возможных типах файлов.
     * Сообщение вида ".pdf, .jpg или .png не более 10 Мб."
     * @param mimeTypesArray
     */
    private prepareInfoMessage(mimeTypesArray: MimeEnums[] = []) {
        const extensionsToShow = mimeTypesArray
            .filter(type => type !== MimeEnums.imageJPEG)
            .map(type => {
                return Boolean(MimeTypeNamespace.extensionsByType[type]) ? '.' + MimeTypeNamespace.extensionsByType[type][0] : null;
            })
            .filter(type => Boolean(type));

        const extMessage = extensionsToShow.slice(
            0,
            extensionsToShow.length - 1
        ).join(', ') + ' или ' + extensionsToShow[extensionsToShow.length - 1];

        this.infoMessage = `${extMessage} не&nbsp;более ${this.maxSize}&nbsp;Мб`;
    }
}
